import { render, staticRenderFns } from "./buyGold.vue?vue&type=template&id=b629e8d6&scoped=true"
import script from "./buyGold.vue?vue&type=script&lang=js"
export * from "./buyGold.vue?vue&type=script&lang=js"
import style0 from "./buyGold.vue?vue&type=style&index=0&id=b629e8d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b629e8d6",
  null
  
)

export default component.exports